<template>
  <li class="item" :class="{ 'active-drop': active }">
    <div @click="click" class="menu-item" v-if="item.sublinks.length > 0">
      <span
        >{{ item.title }}
        <svg
          width="11px"
          height="6px"
          viewBox="0 0 11 6"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Navigation"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            opacity="0.699999988"
          >
            <g
              id="klassik-joined-navi-v2"
              transform="translate(-1310.000000, -21.000000)"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <g
                id="UI/dropdown_arrow"
                transform="translate(1311.000000, 22.000000)"
              >
                <polyline
                  id="Path-2"
                  points="0.375 0.204212135 4.49758538 3.8 8.625 0.2"
                ></polyline>
              </g>
            </g>
          </g>
        </svg>
      </span>

      <transition name="smooth">
        <div
          v-on-clickaway="away"
          class="dropdown"
          v-if="item.sublinks.length > 0 && active"
          :class="grid(item.sublinks.length)"
        >
          <subitem
            v-for="(subItem, index) in activeItem.sublinks"
            :key="index"
            :subitem="subItem"
          ></subitem>
        </div>
      </transition>
    </div>

    <a class="menu-item" :href="item.url" v-else>{{ item.title }}</a>
  </li>
</template>

<script>
import subitem from "./subitem.vue";
import { mixin as clickaway } from "vue-clickaway";

export default {
  components: { subitem },
  mixins: [clickaway],
  props: {
    item: { type: Object, required: true },
    open: { type: Boolean, required: true },
    activeItem: { type: Object, required: false }
  },
  computed: {
    active() {
      return this.activeItem === this.item;
    }
  },
  methods: {
    click(e) {
      this.$emit("clickItem", this.item);
    },
    grid(length) {
      return length == 9
        ? "grid-big"
        : length >= 5 && length != 9
        ? "grid-small"
        : "grid-medium";
    },
    away: function() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  text-transform: uppercase;
  display: inline-block;
  margin: 0 10px;
  color: $dark-grey;
  font-family: $font-text;
  font-size: 14px;
  letter-spacing: 0.54px;
  line-height: 17px;
  cursor: pointer;

  @include res(tab-l) {
    display: block;
    font-size: 20px;
    margin: 0;
    border-bottom: 1px solid #eeeeee;
  }

  a,
  a:focus,
  a:visited {
    color: $dark-grey;
    line-height: 30px;

    @include res(tab-l) {
      display: inline-block;
      padding: 25px 0 25px 20%;
    }

    &#active {
      font-family: $font-text-bold;
    }
  }

  .menu-item {
    span {
      svg {
        width: 13px;
        height: 13px;
        vertical-align: middle;
        transition: transform 100ms ease-in;

        @include res(tab-l) {
          transform: rotate(-90deg);
          width: 18px;
          width: 18px;
        }
      }

      @include res(tab-l) {
        display: flex;
        justify-content: space-between;
        padding: 25px 35px 25px 20%;
        width: 100%;
      }
    }
  }

  &.active-drop {
    .menu-item {
      span {
        font-weight: lighter;
        font-family: $font-text-heavy;

        @include res(tab-l) {
          font-family: $font-text;
          background: $grey;
        }
      }

      svg {
        transform: rotate(0deg);
      }
    }
  }

  .dropdown {
    display: grid;
    position: absolute;
    background-color: $white;
    max-width: 1440px;
    margin: auto;
    width: 100%;
    left: 50%;
    z-index: 15;
    padding: $small-margin $big-margin;
    top: 100px;
    transform: translate(-50%);

    @include res(tab-l) {
      display: block;
      position: initial;
      background-color: transparent;
      max-width: initial;
      width: auto;
      padding: 0;
      transform: none;
      max-height: 1000px;
    }

    @include ie {
      display: -ms-flexbox;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    &.grid-small {
      grid-template-columns: repeat(5, 1fr);
      grid-auto-rows: 215px;
      grid-gap: 25px;
    }

    &.grid-big {
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-gap: $small-margin;

      div.subitem:first-of-type {
        grid-column-start: 1;
        grid-row-start: 1;
        grid-column-end: 3;
        grid-row-end: 3;
      }
    }

    &.grid-medium {
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-gap: 25px;
    }
  }
}

.smooth-enter-active,
.smooth-leave-active {
  transition: all 0.5s;
}
.smooth-enter,
.smooth-leave-to {
  opacity: 0;
}
</style>
